import authRoutes from "./auth/router";
import essRoutes from "./ess/router";
import adminRoutes from "./Admin/router/index";
import permissionRoutes from "./permission/router/index";

export default [
  ...authRoutes,
  ...essRoutes,
  ...adminRoutes,
  ...permissionRoutes,
];
